import React, { useState, useContext } from "react";
import { useDropzone } from "react-dropzone";
import { uploadDocument } from "../api/api";
import { AuthContext } from "../AuthContext";
import { FaSpinner } from "react-icons/fa";

export default function UploadBox() {
  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState(null);
  const { session } = useContext(AuthContext);

  const handleUpload = async (files) => {
    try {
      if (!files || files.length === 0) return;

      setError(null);
      setUploadedFiles(files);
      setUploading(true);
      const uid = session.user.id;

      console.log("Uploading file:", files[0].name);
      const response = await uploadDocument(uid, files[0]);
      console.log("Upload response:", response);

      // Check if response exists and has either a message or data
      if (response && (response.message || response.data)) {
        setUploading(false);
        window.location.reload();
      } else {
        throw new Error("Upload response format invalid");
      }
    } catch (error) {
      console.error("Upload failed:", error);
      setError(error.message);
      setUploading(false);
    }
  };

  const { getRootProps, getInputProps } = useDropzone({
    onDrop: handleUpload,
    accept: {
      "application/pdf": [".pdf"],
    },
    multiple: false,
  });

  return (
    <div className="flex items-center justify-center w-full">
      {uploading ? (
        <div className="flex flex-col items-center justify-center w-full h-64">
          <FaSpinner className="animate-spin text-purple-500" size={48} />
          <span className="mt-2">Uploading...</span>
        </div>
      ) : (
        <div className="w-full">
          <label
            htmlFor="dropzone-file"
            className="flex flex-col items-center justify-center w-full h-64 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50 hover:bg-gray-100"
            {...getRootProps()}
          >
            <div className="flex flex-col items-center justify-center pt-5 pb-6">
              <svg
                className="w-8 h-8 mb-4 text-gray-500"
                aria-hidden="true"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 20 16"
              >
                <path
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2"
                />
              </svg>
              <p className="mb-2 text-sm text-gray-500">
                <span className="font-semibold">Click to upload</span> or drag
                and drop
              </p>
              <p className="text-xs text-gray-500">PDF files only, up to 5MB</p>
            </div>
            <input {...getInputProps()} />
          </label>
          {error && (
            <div className="mt-2 text-red-500 text-sm text-center">{error}</div>
          )}
        </div>
      )}
    </div>
  );
}
